import { Component, OnInit, AfterViewInit } from '@angular/core';

@Component({
  selector: 'app-homepage',
  templateUrl: './public-layout.component.html',
  styleUrls: ['./public-layout.component.scss']
})
export class PublicLayoutComponent implements OnInit, AfterViewInit {

  constructor() { }

  ngOnInit() {

  }

  ngAfterViewInit() {

    // execute the codebase js scripts
    Codebase.helper('ui-init');
    jQuery('.invisible').delay(10000).removeClass('invisible').fadeIn(); // fix this...

  }

}



// WEBPACK FOOTER //
// ./client/app/core/layout/public/public-layout.component.ts